__turbopack_context__.v({
  "className": "ppeditorialnew_b9736c6f-module__ckuCYq__className",
  "variable": "ppeditorialnew_b9736c6f-module__ckuCYq__variable",
});
